import styled from "styled-components";

export const Banner = styled.div<{ $bgColor: string }>`
  align-items: center;
  background-color: ${({ $bgColor }) => $bgColor};
  color: black;
  display: flex;
  justify-content: center;
  margin-bottom: 1.5rem;
  padding: 1rem;
`;

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  flex-direction: column;
  gap: 1rem;

  max-width: calc(1440px + 6rem);
  margin-left: auto;
  margin-right: auto;
  padding-left: 1.25rem;
  padding-right: 1.25rem;

  ${({ theme }) => theme.media.lg} {
    justify-content: space-between;
    flex-direction: row;

    padding-left: 3rem;
    padding-right: 3rem;
  }
`;

export const PrimaryHeading = styled.h1`
  color: ${({ theme }) => theme.colors["black"]};
  font-family: hoefler;
  font-weight: 600;
  width: 100%;
`;

export const SecondaryHeading = styled.h2`
  color: ${({ theme }) => theme.colors["black"]};
  font-family: Avenir;
  font-size: 1.15rem;
  font-weight: 600;
  margin-bottom: 0.75rem;
`;

export const FormContainer = styled.div`
  flex: 1;
`;

export const LineItems = styled.ol`
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const CancelLink = styled.a`
  color: ${({ theme }) => theme.colors["black"]};
  cursor: pointer;
  display: block;
  font-weight: 600;
  padding: 1.5rem 0;
  text-align: center;
  text-decoration: underline;
`;

export const MakeAChangeLink = styled.a`
  color: ${({ theme }) => theme.colors["black"]};
  cursor: pointer;
  text-decoration: underline;
  font-weight: 900;
`;

export const PaymentContainer = styled.div`
  width: 100%;
  max-width: 100%;

  ${({ theme }) => theme.media.lg} {
    width: auto;
    max-width: 30%;
  }
`;

export const Disclaimer = styled.p`
  background-color: ${({ theme }) => theme.colors["papier-blanc"]};
  border-radius: 12px;
  padding: 1.25rem 1.5rem;
  margin: 0.5rem auto 0;
  max-width: fit-content;
`;
